import React, { useState } from "react";
import { TextInput } from "react-native";
export default function ExpandingTextInput(props) {
  const [textHeight, setTextHeight] = useState(props.initialHeight || 0);
  return (
    <TextInput
      multiline
      {...props}
      style={[
        props.style,
        {
          minHeight: textHeight,
        },
      ]}
      onChange={(event) =>
        setTextHeight(event.nativeEvent.srcElement.scrollHeight)
      }
    />
  );
}
